import { create } from 'zustand';
import type { StatBonus } from '../types/progression.types';

export interface LevelUpFeedEntry {
  id: number;
  level: number;
  stats: StatBonus;
}

interface LevelUpFeedState {
  entries: LevelUpFeedEntry[];
  push: (level: number, stats: StatBonus) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useLevelUpFeedStore = create<LevelUpFeedState>((set) => ({
  entries: [],
  push: (level, stats) =>
    set((s) => ({
      entries: [...s.entries, { id: nextId++, level, stats }],
    })),
  dismiss: (id) =>
    set((s) => ({ entries: s.entries.filter((e) => e.id !== id) })),
}));
